export const addMessage = message => ({ type: 'ADD_MESSAGE', message })
export const addMessages = messages => ({ type: 'ADD_MESSAGES', messages })
export const updateMessage = message => ({ type: 'UPDATE_MESSAGE', message })
export const removeMessage = id => ({ type: 'REMOVE_MESSAGE', id })
export const clearMessages = () => ({ type: 'CLEAR_MESSAGES' })
export const updateMessageAnswer = question => ({ type: 'UPDATE_MESSAGE_ANSWER', question })
